var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "table-component",
    {
      ref: "table-component",
      attrs: {
        "add-label": "app-admin-add-affiliate",
        "data-page": "region-list",
        delegate: _vm.delegate,
        title: _vm.t("app-regions"),
      },
      on: { "row-clicked": _vm.rowClicked },
    },
    [
      _c(
        "div",
        { staticClass: "ui-form-row" },
        [
          _c("app-input", {
            attrs: {
              name: "search-input",
              type: "search",
              label: _vm.t("app-search"),
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.delegate.search,
              callback: function ($$v) {
                _vm.$set(_vm.delegate, "search", $$v)
              },
              expression: "delegate.search",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ui-form-row col-filters" },
        [
          _c("md-datepicker", {
            attrs: { label: _vm.t("app-start-date") },
            on: { input: _vm.refresh },
            model: {
              value: _vm.delegate.startDate,
              callback: function ($$v) {
                _vm.$set(_vm.delegate, "startDate", $$v)
              },
              expression: "delegate.startDate",
            },
          }),
          _vm._v(" "),
          _c("md-datepicker", {
            attrs: { label: _vm.t("app-end-date") },
            on: { input: _vm.refresh },
            model: {
              value: _vm.delegate.endDate,
              callback: function ($$v) {
                _vm.$set(_vm.delegate, "endDate", $$v)
              },
              expression: "delegate.endDate",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }